import { Link } from "react-router-dom";
import "./AtlasLaunch.css";

const returnLabels = {
  en: "Back to CRM", pt: "Voltar ao CRM", zh: "返回 CRM", fr: "Retour au CRM",
  es: "Volver al CRM", de: "Zurück zum CRM", it: "Torna al CRM", ru: "Вернуться в CRM", ar: "العودة إلى CRM",
};

export default function AtlasLaunch() {
  const language = localStorage.getItem("panatlantik_language") || "en";
  return (
    <main className="atlas-launch">
      <header className="atlas-launch-header">
        <div className="atlas-launch-identity"><span className="atlas-launch-monogram" aria-hidden="true">P</span><strong>PANATLANTIK ATLAS</strong></div>
        <Link to="/" className="atlas-crm-return">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><path d="m10 7-5 5 5 5M5 12h14" strokeLinecap="round" strokeLinejoin="round" /></svg>
          {returnLabels[language] || returnLabels.en}
        </Link>
      </header>
      <iframe title="PANATLANTIK ATLAS" src="/atlas-app/" />
    </main>
  );
}
